module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-vi.cb9c5c822aad438d7174.svg";